/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-09T14:50:23.958
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveStockpileIntentionOwner,
	getStockpileIntentionOwnerCreateInit,
	getStockpileIntentionOwnerEditInit,
	getStockpileIntentionOwnerView,
	deleteStockpileIntentionOwner
} from '@api/storagemanage/StockpileIntentionOwner';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getStockpileIntentionOwnerCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getStockpileIntentionOwnerCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getStockpileIntentionOwnerEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getStockpileIntentionOwnerEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveStockpileIntentionOwner({}, StockpileIntentionOwner) {
			return new Promise((resolve, reject) => {
				saveStockpileIntentionOwner(StockpileIntentionOwner)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getStockpileIntentionOwnerView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getStockpileIntentionOwnerView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteStockpileIntentionOwner({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteStockpileIntentionOwner({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
